import { ClickAwayListener, Icon, Popover } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { InfoIcon } from './autoCheckReportIcons';

const PopupContainer = styled.div`
  position: absolute;
  background: white;
  padding: 16px 16px 32px 24px;
  border-radius: 8px;
  min-width: 451px;
  z-index: 9999999;
  box-shadow: 0px 4px 4px 0px #00000040;
  border-radius: 20px;
  top: 30px;
  left: 50%;
  opacity: 1;
  transform: translateX(-80%);

  &::before {
    content: '';
    position: absolute;
    z-index: 9999999;
    top: -6px;
    left: 80%;
    transform: translateX(-50%) rotate(45deg);
    width: 12px;
    height: 12px;
    background-color: white;
    border-top: 1px solid #eeeeee;
    border-left: 1px solid #eeeeee;
  }

  @media (max-width: 1024px) {
    min-width: calc(100vw - 32px);
    max-width: calc(100vw - 32px);
    transform: translate(-100%) translate(16px);
  }
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 160px;
  overflow: auto;
`;

const DamageRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const DamageLabel = styled.div`
  font-size: 18px;
  line-height: 32px;
  color: #000;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 24px;
`;

const Title = styled.div`
  font-weight: 500;
  font-size: 22px;
  line-height: 100%;
  color: #000;
`;

type Props = {
  damageInstances: string[];
  close: () => void;
};

export const AutoCheckDamagePopover: React.FC<Props> = ({ damageInstances, close }) => {
  const handleCloseIconClick = (e: any) => {
    e.stopPropagation();
    close();
  };
  return (
    <ClickAwayListener onClickAway={close}>
      <PopupContainer>
        <TitleRow>
          <Title>More Info</Title>
          <div onClick={handleCloseIconClick}>
            <Icon>close</Icon>
          </div>
        </TitleRow>
        <MainContent>
          {damageInstances.map(damage => (
            <DamageRow>
              <InfoIcon />
              <DamageLabel>{damage}</DamageLabel>
            </DamageRow>
          ))}
        </MainContent>
      </PopupContainer>
    </ClickAwayListener>
  );
};
